import {
    HEADER_CLASSNAME,
    HEADER_HEIGHT,
    HEADER_HEIGHT_LG
} from 'consts/header';

/**
 * Utility method which checks for existence of Header and if it exists
 * it returns a number which represents how much of space in layout
 * should be reserved for fixed scrollable header.
 *
 * Used for scrolling to anchors so that content is not hidden
 * under the fixed header.
 *
 * @returns {number}
 */
const getHeaderHeight = () => {
    const BREAKPOINT_LARGE_MIN = 1440;
    const headerExists = document.querySelector(`.${HEADER_CLASSNAME}`);

    if (!headerExists) {
        return 0;
    }

    const largeDeviceQuery = window.matchMedia(
        `(min-width: ${BREAKPOINT_LARGE_MIN}px)`
    );

    const isLargeDeviceQuery = largeDeviceQuery.matches;

    if (isLargeDeviceQuery) {
        return HEADER_HEIGHT_LG;
    }

    return HEADER_HEIGHT;
};

export default getHeaderHeight;
